export const titles = {
  profiles: { id: 'Profile', name: 'A propos' },
  experiences: { id: 'Experience', name: 'Expériences' },
  skills: { id: 'Skill', name: 'Compétences' },
  educations: { id: 'Education', name: 'Formations' }
};
